import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/auth';
import moment from 'moment';
import { FiEdit2, FiSave } from 'react-icons/fi';

import { Message } from './styles';

const ChatMessage = ({ message, currentUser, userObject, editMessage, lastMessage }) => {
    const { userRoles } = useAuth();
    const [isEdit, setIsEdit] = useState(false);
    const [editedText, setEditedText] = useState();


    useEffect(() => {
        if (message && message.text) {
            setEditedText(message.text)
        }
    }, [message]);

    const getMessageSide = () => {
        return currentUser == message.createdBy ? "right" : "left";
    }

    const edit = () => {
        setIsEdit(!isEdit)
        editMessage({...message, text: editedText })
    }


    const messageSide = getMessageSide();
    const isRight = messageSide === "right";

    return <Message >
        <div className={messageSide + " appeared"}>
            {/* Container para tags e metadata - sempre renderizado */}
            <div style={{ 
                display: "flex", 
                justifyContent: "flex-end", 
                alignItems: "center", 
                marginLeft: isRight ? "0" : "20px",
                marginRight: isRight ? "20px" : "0",
                width: "calc(100% - 85px)",
                float: isRight ? "right" : "left"
            }}>
                {/* Renderizar tags apenas se houver tipos definidos */}
                {(message.cultureType || message.country || message.fuelType || message.curingBarn) && (
                    <div style={{ 
                        display: "flex", 
                        flexWrap: "wrap", 
                        gap: "4px",
                        alignItems: "center",
                        marginRight: "auto"
                    }}>
                        {message.cultureType && (
                            <span style={{ 
                                backgroundColor: '#00B1EB',
                                color: 'white',
                                padding: '4px 12px',
                                borderRadius: '5px 5px 0 0',
                                fontSize: '12px',
                                fontWeight: '600',
                                whiteSpace: 'nowrap'
                            }}>
                                {message.cultureType.description || message.cultureType.name}
                            </span>
                        )}
                        {message.country && (
                            <span style={{ 
                                backgroundColor: '#00B1EB',
                                color: 'white',
                                padding: '4px 12px',
                                borderRadius: '5px 5px 0 0',
                                fontSize: '12px',
                                fontWeight: '600',
                                whiteSpace: 'nowrap'
                            }}>
                                {message.country.name}
                            </span>
                        )}
                        {message.fuelType && (
                            <span style={{ 
                                backgroundColor: '#00B1EB',
                                color: 'white',
                                padding: '4px 12px',
                                borderRadius: '5px 5px 0 0',
                                fontSize: '12px',
                                fontWeight: '600',
                                whiteSpace: 'nowrap'
                            }}>
                                {message.fuelType.name}
                            </span>
                        )}
                        {message.curingBarn && (
                            <span style={{ 
                                backgroundColor: '#00B1EB',
                                color: 'white',
                                padding: '4px 12px',
                                borderRadius: '5px 5px 0 0',
                                fontSize: '12px',
                                fontWeight: '600',
                                whiteSpace: 'nowrap'
                            }}>
                                {message.curingBarn.name}
                            </span>
                        )}
                    </div>
                )}
                {/* Metadata sempre renderizada e alinhada à direita */}
                <div style={{ 
                    color: '#999', 
                    fontSize: '12px', 
                    whiteSpace: 'nowrap'
                }}>
                    {message.user} - {moment(message.created, "DD/MM/YYYY HH:mm:ss").add(moment().utcOffset(), "m").format("DD/MM/YYYY HH:mm:ss")}
                </div>
            </div>
            <div className="text_wrapper">
                {
                    !isEdit
                        ?
                        <div className="text">{`${message.text}`}</div>
                        :
                        <textarea className='message_input' value={editedText} onChange={(e) => {
                            setEditedText(e.target.value)
                        }}></textarea>
                }
                {
                    ((userRoles.includes("RoleApprover") && userObject.companyID == null) || userRoles.includes("RoleAdmin")) && currentUser == message.createdBy && lastMessage ? (
                        !isEdit ?
                            <button className="edit_button" onClick={() => {
                                setIsEdit(!isEdit)
                            }}>
                                <FiEdit2
                                    color={"#FFFFFF"}
                                    className="icon-right"
                                    size={14}
                                />
                            </button>
                            :

                            <button className="edit_button" onClick={edit}>
                                <FiSave
                                    color={"#FFFFFF"}
                                    className="icon-right"
                                    size={14}
                                />
                            </button>
                    )
                        : <></>
                }
            </div>
        </div>
    </Message>
}

export default ChatMessage;
